<template>
  <div id="login" class="wp-login">
    <form @submit.prevent="login" class="form-default">
      <img class="logo-pos" src="assets/img/logo-pos.png">
      <div style="text-align:center" v-if="token && salePointStations.length > 1">
        <h4 v-translate >Please choose your sale point</h4><br>
        <div v-for="station in salePointStations">
          <button class="btn btn-lg btn-primary" @click.prevent="pickStation(station.id)">
            <span>{{ printName(station.location, 'locations') }} - {{ station.name }}</span>
          </button><br></br>
        </div>
      </div>
      <div v-else >
        <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <div class="form-group form-group-icon">
          <input class="form-control form-control-lg" type="text" name="username" :placeholder="$gettext('ID / Username')" v-model="input.username"/>
        </div>
        <div class="form-group form-group-icon">
          <input class="form-control form-control-lg" type="password" :placeholder="$gettext('Password')" name="password" v-model="input.password"/>
        </div>
        <div class="form-footer">
          <div class="row">
            <div class="col-4">
              <select class="form-control mb-3 btn-lg language" @change="setLanguage" :value="$language.current">
                <option v-for="(language, key) in languageSelect" :key="key" :value="language.value">{{ language.text }}</option>
              </select>
            </div>
            <div class="col-6 offset-2">
              <button class="btn btn-lg btn-primary w-100" type="submit">
                <span v-translate>Log-in</span>
              </button>
            </div>
            <div class="col-12 text-center mt-3">
              <a href="#" class="form-footer-text">
                <icon name="fingerprint" />
                <span v-translate>Touch for log in</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import SettingService from "@/services/SettingService";
import LocationTableService from "@/services/LocationTableService";
import { SET_MESSAGE_MODAL } from '@/store/mutation-types';
import MonthlyDeliveryCoordinator from '@/services/MonthlyDeliveryCoordinator';

export default {
  name: 'Login',
  data() {
    return {
      input: {
        username: '',
        password: '',
      },
      errorMessage: '',
    };
  },
  computed: {
    languageSelect() {
      const language = this.getArray('settings').find(lang => lang.name === 'language');
      let rs = [];
      const languages = [];
      if (language && language.value) {
        rs = language.value.split(',');
      }
      Object.keys(this.$language.available).forEach((key) => {
        if (rs.includes(key)) {
          languages.push({
            text: this.$language.available[key],
            value: key,
          });
        }
      });
      return languages;
    },
    token() { return this.getMap('token', true); },
    user() { return this.getMap('user', true); },
    salePointStations() {
      return this
        .getArray('stations', true)
        .filter(station => station.isSalePoint);
    },
  },
  watch: {
    async salePointStations(value) {
      if (this.user.location) {
        await this.fetchLocationTable();
      }

      if (value.length == 1 && this.token) {
        this.pickStation(value[0].id);
      }
    },
  },
  methods: {
    loginUserHasCashierPermission() {
      const permissions = (this.user && this.user.permissions) ? this.user.permissions : [];
      return permissions.includes('toggle_staff_sign_in');
    },
    isShiftCashierCurrentUser(shift) {
      if (!shift || !shift.user || !this.user) return false;
      const shiftUserId = typeof shift.user === 'object' ? shift.user.id : shift.user;
      return String(shiftUserId) === String(this.user.id);
    },
    notifySessionRoleContext({ workDay, shift }) {
      const hasCashierPermission = this.loginUserHasCashierPermission();
      const hasWorkDay = !!workDay;
      const hasShift = !!shift;

      if (!hasCashierPermission && (!hasWorkDay || !hasShift)) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext('A cashier must start day and shift for this station before order staff can use it.')
        );
        return false;
      }

      if (hasCashierPermission && hasShift && !this.isShiftCashierCurrentUser(shift)) {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext('You are signed in as order staff for this shift. Cashier actions are unavailable.')
        );
      }

      return true;
    },
    setLanguage(language) {
      this.$language.current = language.target.value;
      localStorage.setItem('pos-language', language.target.value);
    },
    login() {
      if (this.input.username !== '' && this.input.password !== '') {
        AuthService.login(this.input);
      } else {
        this.errorMessage = this.$gettext(
          "A username and password must be present"
        );
      }
    },
    async fetchLocationTable() {
      let tables = await LocationTableService.list(this.user.location.id);
      if (tables.count) {
        this.$store.commit('setLocationTable', {
          locationId: this.user.location.id,
          tables: tables.data
        } );
      }
    },
    async pickStation(station) {
      const response = await AuthService.pickStation(station);
      if (response) {
        const canEnterOrder = this.notifySessionRoleContext({
          workDay: response.workDay,
          shift: response.shift || null,
        });

        if (!canEnterOrder) {
          return;
        }

        this.user.station = this.getObject(station, 'stations');
        this.user.location = this.getObject(this.user.station.location, 'locations');
        this.user.workDay = response.workDay;
        this.user.shift = response.shift || null;
        localStorage.setItem('pos_user', JSON.stringify(this.user));
        try {
          await MonthlyDeliveryCoordinator.check({
            locationId: this.user.location.id,
            stationId: this.user.station.id,
          });
        } catch (error) {
          this.$store.commit(SET_MESSAGE_MODAL, this.$gettext('Monthly report delivery failed: ') + error.message);
        }
        this.$router.replace({ name: 'order' });
      }
    },
  },
};
</script>
